import html from "./launcher-button.html?raw"
import styles from "./launcher-button.css?inline"
import { sharedStyles } from "../../shared-styles"
import { openOrFocusLauncher } from "../../launcher-window"

class LauncherButton extends HTMLElement {
  private btn!: HTMLButtonElement

  constructor() {
    super()
    const template = document.createElement("template")
    template.innerHTML = `<style>${styles}</style>${html}`
    const shadow = this.attachShadow({ mode: "open" })
    shadow.adoptedStyleSheets = [sharedStyles]
    shadow.appendChild(template.content.cloneNode(true))
  }

  connectedCallback() {
    this.btn = this.shadowRoot!.querySelector("button")!
    this.btn.addEventListener("click", () => openOrFocusLauncher())

    // Purely event-driven: each page calls bootstrapStoreState() on load to
    // emit a store-state-bootstrap event with the current hasData. After
    // that, store-updated/store-cleared events carry transitions. This
    // keeps launcher-button free of any graph-store import.
    document.addEventListener("store-updated", this.handleStoreUpdated)
    document.addEventListener("store-cleared", this.handleStoreCleared)
    document.addEventListener(
      "store-state-bootstrap",
      this.handleStoreStateBootstrap,
    )
  }

  disconnectedCallback() {
    document.removeEventListener("store-updated", this.handleStoreUpdated)
    document.removeEventListener("store-cleared", this.handleStoreCleared)
    document.removeEventListener(
      "store-state-bootstrap",
      this.handleStoreStateBootstrap,
    )
  }

  private handleStoreUpdated = () => {
    this.btn.classList.add("has-data")
  }

  private handleStoreCleared = () => {
    this.btn.classList.remove("has-data")
  }

  private handleStoreStateBootstrap = (e: Event) => {
    const { hasData } = (e as CustomEvent<{ hasData: boolean }>).detail
    this.btn.classList.toggle("has-data", hasData)
  }
}

customElements.define("launcher-button", LauncherButton)
export { LauncherButton }
